<template>
  <footer class="footer">
    <div class="footer-bottom">
      <p>版权归通川区中医院所有 | 备案号：蜀ICP备19002635号-4</p>
      <p>急救电话：2141120 、咨询电话：2122808 2149989</p>
      <p>
        地址：通川区文华街75号（老院区）、通川区莲花湖管委会石莲花社区5组（新院区）
      </p>
    </div>
  </footer>
</template>

<script>
import { ref, computed, onMounted } from "vue";

export default {
  name: "AppFooter",
  setup() {
    const currentYear = computed(() => {
      return new Date().getFullYear();
    });

    const currentTime = ref("");

    const updateCurrentTime = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");

      currentTime.value = `${year}-${month}-${day} ${hours}:${minutes}`;
    };

    onMounted(() => {
      updateCurrentTime();
      // 更新时间，每分钟更新一次
      setInterval(updateCurrentTime, 60000);
    });

    return {
      currentYear,
      currentTime,
    };
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: #f5f5f5;
  color: #333;

  .footer-main {
    padding: 60px 0 30px;

    .footer-columns {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 30px;
      margin-bottom: 40px;

      @media (max-width: 1200px) {
        grid-template-columns: repeat(3, 1fr);
      }

      @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 576px) {
        grid-template-columns: 1fr;
      }
    }

    .footer-column {
      h3 {
        font-size: 18px;
        color: #163c7d;
        margin-bottom: 20px;
        font-weight: 500;
        position: relative;
        padding-bottom: 12px;

        &::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 40px;
          height: 2px;
          background-color: #163c7d;
        }
      }

      .footer-links {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
          margin-bottom: 12px;

          a {
            color: #666;
            text-decoration: none;
            font-size: 14px;
            transition: all 0.3s;
            position: relative;
            padding-left: 15px;

            &::before {
              content: "";
              position: absolute;
              left: 0;
              top: 8px;
              width: 5px;
              height: 5px;
              border-radius: 50%;
              background-color: #ccc;
            }

            &:hover {
              color: #163c7d;
              padding-left: 18px;

              &::before {
                background-color: #163c7d;
              }
            }
          }
        }
      }

      &.contact-column {
        @media (max-width: 1200px) {
          grid-column: span 3;
        }

        @media (max-width: 768px) {
          grid-column: span 2;
        }

        @media (max-width: 576px) {
          grid-column: span 1;
        }

        .contact-info {
          list-style: none;
          padding: 0;
          margin: 0;

          li {
            margin-bottom: 12px;
            display: flex;
            align-items: flex-start;
            color: #666;
            font-size: 14px;

            i {
              color: #163c7d;
              margin-right: 10px;
              font-size: 16px;
              margin-top: 2px;
            }
          }
        }

        .qrcode-container {
          margin-top: 20px;
          display: flex;
          align-items: center;

          .qrcode {
            text-align: center;

            .qrcode-img {
              width: 100px;
              height: 100px;
              padding: 5px;
              border: 1px solid #e0e0e0;
              background-color: #fff;
            }

            p {
              margin: 8px 0 0;
              font-size: 13px;
              color: #666;
            }
          }
        }
      }
    }

    .footer-bottom-section {
      padding-top: 30px;
      border-top: 1px solid #e0e0e0;

      .footer-bottom-info {
        display: flex;
        justify-content: space-between;
        align-items: center;

        @media (max-width: 992px) {
          flex-direction: column;
          gap: 30px;
          align-items: flex-start;
        }

        .footer-logo {
          display: flex;
          align-items: center;

          .logo-img {
            width: 60px;
            height: 60px;
            margin-right: 15px;
          }

          .company-info {
            h2 {
              font-size: 20px;
              color: #163c7d;
              margin: 0 0 5px;
            }

            p {
              font-size: 14px;
              color: #666;
              margin: 0;
            }
          }
        }

        .stock-info {
          .stock-title {
            font-size: 16px;
            color: #163c7d;
            margin-bottom: 10px;
            font-weight: 500;
          }

          .stock-grid {
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            gap: 15px;

            .stock-item {
              background-color: #fff;
              padding: 15px;
              border-radius: 4px;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
              display: flex;
              flex-direction: column;

              .stock-code {
                font-size: 14px;
                color: #666;
                margin-bottom: 8px;
              }

              .stock-price {
                font-size: 18px;
                font-weight: 600;
                color: #333;
                margin-bottom: 5px;

                i {
                  font-size: 14px;
                  margin-left: 5px;
                }
              }

              .stock-time {
                font-size: 12px;
                color: #999;
              }
            }
          }
        }
      }
    }
  }

  .footer-bottom {
    background: url("./../assets/images/pageImage/newsDiv.png");
    color: #fff;
    padding: 40px 0;

    p {
      text-align: center;
      font-size: 15px;
    }

    .page-container {
      display: flex;
      justify-content: space-between;
      align-items: center;

      @media (max-width: 768px) {
        flex-direction: column;
        gap: 15px;
      }
    }

    .copyright {
      p {
        margin: 0;
        font-size: 14px;
        opacity: 0.8;

        &:first-child {
          margin-bottom: 5px;
        }

        span {
          color: #ff9800;
        }
      }
    }

    .footer-nav {
      display: flex;
      gap: 20px;

      a {
        color: #fff;
        opacity: 0.8;
        text-decoration: none;
        font-size: 14px;

        &:hover {
          opacity: 1;
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
